import { useMarketQuery } from '@/composables/market.ts';
import { calculateRentalMonths, getRentalDuration } from '@containex/portal-business-logic';
import { QuantityUnit } from '@containex/portal-backend-dto';

export interface RentalDurationCalculator {
    calculateRentalDurationDays(rentalStart?: Date, rentalEnd?: Date): number;
    calculateSelectedRentalDurationDays(rentalStart?: Date, rentalEnd?: Date): number;
    calculateRentalDurationMonths(rentalStart?: Date, rentalEnd?: Date): number;

    calculateRentalDurationDaysForParameters(
        rentalStart?: Date,
        rentalEnd?: Date,
        minimumRentalDuration?: number,
        rentalUnit?: QuantityUnit
    ): number;
    calculateRentalDurationMonthsForParameters(
        rentalStart?: Date,
        rentalEnd?: Date,
        minimumRentalDuration?: number
    ): number;
}

export function useRentalDurationCalculator(): RentalDurationCalculator {
    return {
        calculateRentalDurationDays(rentalStart?: Date, rentalEnd?: Date): number {
            const market = useMarketQuery().market?.value;
            if (rentalStart == null || rentalEnd == null) {
                return 0;
            }
            return getRentalDuration(rentalStart, rentalEnd, market?.minimumRentalDuration, market?.rentalUnit);
        },
        calculateSelectedRentalDurationDays(rentalStart?: Date, rentalEnd?: Date): number {
            if (rentalStart == null || rentalEnd == null) {
                return 0;
            }
            return getRentalDuration(rentalStart, rentalEnd, 0, QuantityUnit.PER_DAY);
        },
        calculateRentalDurationMonths(rentalStart?: Date, rentalEnd?: Date): number {
            const market = useMarketQuery().market?.value;
            if (rentalStart == null || rentalEnd == null) {
                return 0;
            }
            return calculateRentalMonths(rentalStart, rentalEnd, market?.minimumRentalDuration ?? 0);
        },
        calculateRentalDurationDaysForParameters(
            rentalStart?: Date,
            rentalEnd?: Date,
            minimumRentalDuration?: number,
            rentalUnit?: QuantityUnit
        ): number {
            if (rentalStart == null || rentalEnd == null) {
                return 0;
            }
            return getRentalDuration(rentalStart, rentalEnd, minimumRentalDuration, rentalUnit);
        },
        calculateRentalDurationMonthsForParameters(
            rentalStart?: Date,
            rentalEnd?: Date,
            minimumRentalDuration?: number
        ): number {
            if (rentalStart == null || rentalEnd == null) {
                return 0;
            }
            return calculateRentalMonths(rentalStart, rentalEnd, minimumRentalDuration ?? 0);
        },
    };
}
